(function() {

    var options = [ 'start', 'range', 'connect', 'margin', 'limit', 'padding', 'step', 'orientation', 'direction', 'tooltips', 'animate' ];

    Vue.component('nouislider', {
        props: options,
        watch: buildRefreshWatchers(),
        mounted: function() {
            if (!this.slider) {
                this.slider = noUiSlider.create(this.$el, createNoUiPackage.apply(this));

                var self = this;
                this.slider.on('change', function(value) {
                    if (Array.isArray(value) && Array.isArray(self.start)) {
                        self.start.length = value.length;
                        for(var i = 0; i < value.length; i++) {
                            self.start[i] = value[i];
                        }
                    } else {
                        self.start = value;
                    }
                });
            }
        },
        destroyed: function() {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
        },
        template: '<div class="noui-slider-vue"></div>'
    });

    function createNoUiPackage() {
        var package = {};
        for(var i = 0; i < options.length; i++) {
            var name = options[i];
            package[name] = prepareParameter(name, this[name]);
        }

        return package;
    }

    function buildRefreshWatchers() {
        var watchers = {};
        for(var i = 0; i < options.length; i++) {
            var name = options[i];
            watchers[name] = createWatcher(name);
        }

        return watchers;
    }

    function createWatcher(option) {
        return function(newValue) {
            if (this.slider) {
                var update = {};
                update[option] = prepareParameter(option, newValue);
                this.slider.updateOptions(update, false);
            }
        };
    }

    function prepareParameter(name, value) {
        if (name === 'range' && Array.isArray(value)) {
            return { min: value[0], max: value[1] };
        }

        return value;
    }

})();